import { apiSlice } from "./apiSlice";
import { USERS_URL } from "../constants";

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // Login user
    login: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth`,
        method: "POST",
        body: data,
      }),

      invalidatesTags: ["User"],
    }),

    // Forgot password
    // POST /api/users/forgot-password
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/forgot-password`,
        method: "POST",
        body: data,
      }),
    }),

    // Get password reset requests
    // GET /api/users/forgot-password
    //
    // Returns only requests belonging to
    // the currently authenticated center admin.
    getForgotPasswordUsers: builder.query({
      query: () => ({
        url: `${USERS_URL}/forgot-password`,
        method: "GET",
      }),

      providesTags: ["User"],

      keepUnusedDataFor: 5,
    }),

    // Reset user password
// PUT /api/users/:id/reset-password
//
// Access:
// centerAdmin only
resetUserPassword: builder.mutation({
  query: (userId) => ({
    url: `${USERS_URL}/${userId}/reset-password`,
    method: "PUT",
  }),

  invalidatesTags: ["User"],
}),

    // Register user
    register: builder.mutation({
      query: (data) => ({
        url: USERS_URL,
        method: "POST",
        body: data,
      }),

      invalidatesTags: ["User"],
    }),

    // Change password
    changePassword: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/change-password`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: ["User"],
    }),

    // Logout
    logout: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/logout`,
        method: "POST",
      }),

      invalidatesTags: ["User"],
    }),

    // Get logged-in user profile
    getProfile: builder.query({
      query: () => ({
        url: `${USERS_URL}/profile`,
      }),

      providesTags: ["User"],

      keepUnusedDataFor: 5,
    }),

    // Get students
    getStudents: builder.query({
      query: ({ coachingCenter, search } = {}) => ({
        url: `${USERS_URL}/students`,
        params: {
          ...(coachingCenter && { coachingCenter }),
          ...(search && { search }),
        },
      }),

      providesTags: ["User"],

      keepUnusedDataFor: 5,
    }),

    // Update logged-in user profile
    updateProfile: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/profile`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: ["User"],
    }),

    // Get all users of current coaching center
    getUsers: builder.query({
      query: () => ({
        url: USERS_URL,
      }),

      providesTags: ["User"],

      keepUnusedDataFor: 5,
    }),

    // Delete user
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `${USERS_URL}/${userId}`,
        method: "DELETE",
      }),

      invalidatesTags: ["User"],
    }),

    // Get user details
    getUserDetails: builder.query({
      query: (id) => ({
        url: `${USERS_URL}/${id}`,
      }),

      providesTags: ["User"],

      keepUnusedDataFor: 5,
    }),

    // Update user by admin
    updateUser: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/${data.userId}`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useLoginMutation,

  useForgotPasswordMutation,

  useGetForgotPasswordUsersQuery,

  useResetUserPasswordMutation,

  useLogoutMutation,

  useRegisterMutation,

  useChangePasswordMutation,

  useGetProfileQuery,

  useUpdateProfileMutation,

  useGetUsersQuery,

  useDeleteUserMutation,

  useGetUserDetailsQuery,

  useGetStudentsQuery,

  useUpdateUserMutation,

} = userApiSlice;